export const AVAILABLE_TRANSCRIPTIONS_LANG = ['en-au', 'en-gb', 'en-us', 'en-ie', 'es-es', 'es-mx']

export const isVoicemailTranscriptionLangSupported = (pbxDefaultLang, lineLang) => lineLang ? AVAILABLE_TRANSCRIPTIONS_LANG.includes(lineLang) : AVAILABLE_TRANSCRIPTIONS_LANG.includes(pbxDefaultLang)
